require('./angular');
module.exports = angular;



//////////////////
// WEBPACK FOOTER
// ./~/angular/index.js
// module id = 55
// module chunks = 1